import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import IntegrationCard from "examples/Cards/InfoCards/IntegrationCard";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";

const apiUrl = "https://api.getverceipt.com/api/v1";

import useAuthorsTableData from "layouts/integrations/data/storesTableData";
import SoftButton from "components/SoftButton";
import { AddRounded, CheckRounded, RefreshRounded } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import SoftInput from "components/SoftInput";
import { useSnackbar } from "providers/SnackbarProvider";

function Tables() {
  const [projects, setProjects] = useState([
    { id: 1, title: "Ingenico", label: "", image: "https://t3.ftcdn.net/jpg/03/24/73/92/360_F_324739203_keeq8udvv0P2h1MLYJ0GLSlTBagoXS48.jpg", oauthLink: "" },
    { id: 2, title: "Square", label: "", image: "https://t3.ftcdn.net/jpg/03/24/73/92/360_F_324739203_keeq8udvv0P2h1MLYJ0GLSlTBagoXS48.jpg", oauthLink: "" },
    { id: 3, title: "Lightspeed", label: "", image: "https://t3.ftcdn.net/jpg/03/24/73/92/360_F_324739203_keeq8udvv0P2h1MLYJ0GLSlTBagoXS48.jpg", oauthLink: "" },
  ]);

  const {rows, columns, loading, setLoading } = useAuthorsTableData();

  const [open, setOpen] = useState(false);
  const [deviceName, setDeviceName] = useState("");
  const [deviceStore, setDeviceStore] = useState("");

  const [deviceNameErr, setdeviceNameErr] = useState(false);

  const [syncing, setSyncing] = useState(false);

  const { showSnackbar } = useSnackbar();

  const handleSubmit = async () => {

  };

  const attemptRefresh = async () => {
    try {
      setSyncing(true);
      const response = await fetch(`${apiUrl}/business/devices/sync`, {
        method: 'POST',
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json().catch(() => ({}));
      
      if(response.ok) {
        showSnackbar("Successfully requested a resync from external provider.", "success");
      } else {
        const errorMsg = data?.error || `Request failed with status ${response.status}`;
        console.error("Resync error:", errorMsg);
        showSnackbar(errorMsg, "error");
      }
    } catch (err) {
      showSnackbar(`${err}`, "error");
    } finally {
      setSyncing(false);
    }
  };

  useEffect(() => {
    const fetchOAuthLinks = async () => {
      const updatedProjects = await Promise.all(
        projects.map(async (project) => {
          try {
            // convert title to lowercase for endpoint
            const provider = project.title.toLowerCase();
            const response = await fetch(`${apiUrl}/integrations/${provider}/request`, {
              method: 'POST',
              withCredentials: true,
              credentials: 'include', // make sure cookies/session are sent
              headers: {
                'Content-Type': 'application/json',
              },
            });
            const data = await response.json();
            console.log(data.url)
            return { ...project, oauthLink: data.url, linked: data.linked }; // assuming API returns { link: "..." }
          } catch (error) {
            console.error(`Error fetching OAuth link for ${project.title}:`, error);
            return { ...project, oauthLink: "#", linked: false }; // fallback
          }
        })
      );
      setProjects(updatedProjects);
    };

    fetchOAuthLinks();
  }, []); // run once on mount

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox>
        <SoftBox p={3}>
          <Grid container spacing={3}>
            {projects.map((project) => {
              const anyLinked = projects.some((p) => p.linked);
              const isLinked = project.linked;
              const disableButton = anyLinked && !isLinked;
              console.log(anyLinked, isLinked, disableButton)

              return (
                <Grid item xs={12} sm={6} md={4} key={project.id}>
                  <IntegrationCard
                    icon="account_balance"
                    title={project.title}
                    description={project.label}
                    buttonText={
                      isLinked ? (
                        <>
                          <CheckRounded /> Connected
                        </>
                      ) : (
                        disableButton ? "EXISTING INTEGRATION ACTIVE" : "Connect"
                      )
                    }
                    buttonColor={disableButton ? "secondary" : (isLinked ? "success" : "error")}
                    onButtonClick={() => !disableButton && window.open(project.oauthLink, "_blank")}
                    disabled={disableButton}
                  />
                </Grid>
              );
            })}

          </Grid>
        </SoftBox>

        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6">Linked devices</SoftTypography>

              {/* Button group */}
              <SoftBox display="flex" gap={1}>
                <SoftButton variant="contained" color="secondary" onClick={() => setOpen(true)}>
                  <AddRounded /> Add manual device
                </SoftButton>

                <SoftButton variant="contained" color="info" onClick={() => attemptRefresh()} disabled={syncing}>
                  <RefreshRounded /> Sync devices
                </SoftButton>
              </SoftBox>
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {loading ? (
                <SoftTypography p={3} variant="body2">
                  Loading team...
                </SoftTypography>
              ) : (
                <Table columns={columns} rows={rows} />
              )}
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Add a new device</DialogTitle>
        <DialogContent>
          <SoftBox display="flex" gap={3} alignItems="flex-start" flexWrap="wrap">
          <FormControl sx={{ minWidth: 200 }}>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={deviceStore}
              onChange={(e) => setDeviceStore(e.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
            <FormHelperText>Select linked store..</FormHelperText>
          </FormControl>

          <FormControl sx={{ minWidth: 75 }}>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={deviceStore}
              onChange={(e) => setDeviceStore(e.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
            <FormHelperText>Select integration provider..</FormHelperText>
          </FormControl>
          <SoftInput
            autoFocus
            margin="dense"
            placeholder="Enter new device name here.."
            type="text"
            fullWidth
            value={deviceName}
            error={deviceNameErr}
            onChange={(e) => setDeviceName(e.target.value)}
          />

          <SoftInput
            autoFocus
            margin="dense"
            placeholder="Enter device serial ID from provider.."
            type="text"
            fullWidth
            value={deviceName}
            error={deviceNameErr}
            onChange={(e) => setDeviceName(e.target.value)}
          />

          </SoftBox>
        </DialogContent>
        <DialogActions>
          <SoftButton onClick={() => setOpen(false)} color="error">Cancel</SoftButton>
          <SoftButton variant="contained" color="success" onClick={handleSubmit}>
            Add
          </SoftButton>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
